import { Autocomplete } from 'stimulus-autocomplete'

export default class CustomAutocomplete extends Autocomplete {

}